import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { updateRentalPortalListing } from '../../../../../../api'
import { EVENT_KEY_ESCAPE } from '../../../../../../constants/event'
import { QA_NAME_SAVE_BTN } from '../../../../../../constants/qa'
import { useKeyboardListener } from '../../../../../../hooks'
import { parseServerValidation } from '../../../../../../utils/validation'
import { EntityProfileHeaderEditTitleModal } from '../../../../../Entity'
import { getIsListingChangedConflictError } from '../../../../../RentalPortalListing'

import { QA_NAME_LISTING_EDIT_TITLE_MODAL } from './ListingEditTitleModal.constants'
import { getListingEditTitleValidationSchema } from './ListingEditTitleModal.utils'
import { ListingEditTitleModalFields } from './ListingEditTitleModalFields'

function ListingEditTitleModal({
  initialValues,
  listingId,
  version,
  onClose,
  onConflict,
  onSave,
}) {
  const { t } = useTranslation()

  const [isDirty, setDirty] = useState(false)

  function handleEscape() {
    if (!isDirty) {
      onClose()
    }
  }

  useKeyboardListener({
    callback: handleEscape,
    dependencies: [isDirty, onClose],
    eventKey: EVENT_KEY_ESCAPE,
  })

  async function handleSubmit({ setErrors, setSubmitting, value }) {
    return updateRentalPortalListing({ data: value, id: listingId, version })
      .then(onSave)
      .catch(error => {
        setSubmitting(false)

        if (getIsListingChangedConflictError(error)) {
          onConflict(error)
        } else {
          setErrors(
            parseServerValidation(
              t('RentalPortal.ListingProfileTitleSaveErrorKey')
            )
          )
        }
      })
  }

  return (
    <EntityProfileHeaderEditTitleModal
      Fields={ListingEditTitleModalFields}
      containerProps={{
        qaName: QA_NAME_LISTING_EDIT_TITLE_MODAL,
        onIsDirtyChange: setDirty,
      }}
      formBodyProps={{
        submitQaName: QA_NAME_SAVE_BTN,
        withNotifications: true,
      }}
      initialValues={initialValues}
      validationSchema={getListingEditTitleValidationSchema({
        initialValues,
        t,
      })}
      onClose={onClose}
      onSubmit={handleSubmit}
    />
  )
}

export default ListingEditTitleModal
